const DEFAULT_PAYMENT_METHODS = ["CARD", "BANK_TRANSFER", "APPLE_PAY", "SADAD"];

export const normalizePaymentMethod = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/[-\s]+/g, "_");

  return DEFAULT_PAYMENT_METHODS.includes(normalized) ? normalized : null;
};

export const normalizePaymentMethods = (methods, fallback = DEFAULT_PAYMENT_METHODS) => {
  const source = Array.isArray(methods) ? methods : fallback;
  const normalized = source
    .map(normalizePaymentMethod)
    .filter(Boolean);

  return normalized.length > 0 ? normalized : [...fallback];
};

